/**
 * The tax year a firm is usually working on: last year, until December, when
 * organizers for the current year start going out.
 */
export function defaultTaxYear(now = new Date()): number {
  return now.getMonth() === 11 ? now.getFullYear() : now.getFullYear() - 1;
}

export function formatDate(value: string | Date | null | undefined): string {
  if (!value) return "—";
  // Plain calendar dates (YYYY-MM-DD) must not shift with the time zone.
  const d = typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value) ? new Date(`${value}T12:00:00`) : new Date(value);
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
}

export function formatDateTime(value: string | Date): string {
  return new Date(value).toLocaleString("en-US", { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
}

export function formatBytes(n: number): string {
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(0)} KB`;
  return `${(n / 1024 / 1024).toFixed(1)} MB`;
}

export function initials(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]!.toUpperCase())
    .join("");
}

/** Today's calendar date in the browser's time zone, as YYYY-MM-DD. */
export function localToday(now = new Date()): string {
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
}

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

/** A work period for display: "2026-09" reads "Sep 2026"; tax years and free text are shown as stored. */
export function formatPeriod(period: string | null | undefined): string {
  if (!period) return "";
  const m = /^(\d{4})-(\d{2})$/.exec(period);
  return m && Number(m[2]) >= 1 && Number(m[2]) <= 12 ? `${MONTHS[Number(m[2]) - 1]} ${m[1]}` : period;
}

/** Whole days from one calendar date to another (positive when `to` is later). */
export function daysBetween(from: string, to: string): number {
  return Math.round((Date.parse(`${to}T12:00:00Z`) - Date.parse(`${from}T12:00:00Z`)) / 86_400_000);
}

/** A count with its noun, singular for one: "1 section", "4 sections", "1,204 files". */
export function plural(n: number, one: string, many = `${one}s`): string {
  return `${n.toLocaleString()} ${n === 1 ? one : many}`;
}
